
export default {
  data() {
    return {
      options: [
        {
          name: "question",
          label: "Pitanje",
          type: "text",
        },
        {
          name: "answer",
          label: "Odgovor",
          type: "tipTap",
        },
      ],
    };
  },
  methods: {
    onToggle(event, index) {
      if (event.target.open) {
        this.closeOtherDetails(index);
      }
    },
    closeOtherDetails(openIndex) {
      this.$refs.details.forEach((details, index) => {
        if (index !== openIndex) {
          details.open = false;
        }
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
